import { render, staticRenderFns } from "./tipsMask.vue?vue&type=template&id=a0b1b30a&scoped=true"
import script from "./tipsMask.vue?vue&type=script&lang=js"
export * from "./tipsMask.vue?vue&type=script&lang=js"
import style0 from "./tipsMask.vue?vue&type=style&index=0&id=a0b1b30a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b1b30a",
  null
  
)

export default component.exports